import React from 'react';
import PropTypes from 'prop-types';

import isNil from 'lodash/isNil';
import noop from 'lodash/noop';

import classNames from 'classnames';
import { Icon } from 'shared/components';

import isBase64Image from 'modules/user/utils/isBase64Image';
import { AccessibilityContext } from 'App';

import theme from './IconWithDotBadge.scss';

const propTypes = {
  name: PropTypes.string,
  inverted: PropTypes.bool,
  userInfo: PropTypes.shape({
    avatar: PropTypes.string,
    initials: PropTypes.string,
  }),
  onClick: PropTypes.func,
  iconWidth: PropTypes.string,
  iconFontSize: PropTypes.string,
  titleFontSize: PropTypes.string,
  color: PropTypes.string,
  withoutBackground: PropTypes.bool,
  isDisabled: PropTypes.bool,
  unavailable: PropTypes.bool,
};

const defaultProps = {
  iconWidth: '30px',
  iconFontSize: '18px',
  titleFontSize: '15px',
  inverted: null,
  name: null,
  userInfo: null,
  onClick: noop,
  color: '',
  withoutBackground: false,
  isDisabled: false,
  unavailable: null,
};

const DefaultIconWithDotBadge = ({
  name,
  inverted,
  userInfo,
  onClick,
  color,
  iconWidth,
  iconFontSize,
  withoutBackground,
  titleFontSize,
  isDisabled,
  unavailable,
}) => {

  const hasUserAvatar = !isNil(userInfo)
    && !isNil(userInfo.avatar)
    && isBase64Image(userInfo.avatar);

  const hasUserInfo = !isNil(userInfo)
    && (!isNil(userInfo.avatar) || !isNil(userInfo.initials));


  return (
    <div
      onClick={ onClick }
      style={{
        width: iconWidth,
        height: iconWidth,
        fontSize: iconFontSize,
      }}
      className={
        classNames(
          theme.root,
          {
            [theme.inverted]: inverted,
            [theme.transparent]: hasUserAvatar,
            [theme.highlightedGreen]: color === 'green',
            [theme.highlightedRed]: color === 'red',
            [theme.mediumRed]: color === 'mediumRed',
            [theme.backHidden]: withoutBackground,
            [theme.disabled]: !withoutBackground && isDisabled,
            [theme.unavailable]: unavailable,
          },
        )
      }
    >
      <Choose>
        <When condition={ hasUserInfo }>
          <Choose>
            <When condition={ hasUserAvatar }>
              <div
                className={ theme.avatar }
                style={{
                  backgroundImage: `url(data:image/svg+xml+jpg+jpeg+png;${ userInfo.avatar })`,
                }}
              />
            </When>
            <Otherwise>
              <span style={{ fontSize: titleFontSize }} >
                { userInfo.initials }
              </span>
            </Otherwise>
          </Choose>
        </When>
        <Otherwise>
          <Icon name={ name } />
        </Otherwise>
      </Choose>
    </div>
  );
};

DefaultIconWithDotBadge.propTypes = propTypes;
DefaultIconWithDotBadge.defaultProps = defaultProps;

export default DefaultIconWithDotBadge;
